// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `input { outline: none; font-weight: normal; }`, "",{"version":3,"sources":["webpack://./src/Theme/Components/input.css"],"names":[],"mappings":"AAAA,QAAQ,aAAa,EAAE,mBAAmB,EAAE","sourcesContent":["input { outline: none; font-weight: normal; }"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
